<!--
* @Name：议价审批物料信息明细详情
* @Author: 刘玉
* @Date: 2021-12-02 16:13:46
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 16:13:46
-->
<template>
  <van-dialog
    :value="detailsVisible"
    title="详细信息"
    show-cancel-button
    cancel-button-text="关闭"
    cancel-button-color="#1989fa"
    :show-confirm-button="false"
    @cancel="close"
  >
    <div class="details-container">
      <hi-cell title="供应商名称：" :value="detailsInfo.suppName"></hi-cell>
      <hi-cell title="采购数量：" :value="detailsInfo.purchaseQty"></hi-cell>
      <hi-cell title="基本单位：" :value="detailsInfo.baseUnit"></hi-cell>
      <hi-cell title="基本单位说明：" :value="detailsInfo.baseUnitDesc"></hi-cell>
      <hi-cell title="品牌：" :value="detailsInfo.agentBrand"></hi-cell>
      <hi-cell title="供货品类：" :value="getCatgName(detailsInfo.mtartIn)"></hi-cell>
      <hi-cell title="曾定价历史最低价：" :value="getHistoryPriceList(detailsInfo.matnr)"></hi-cell>
    </div>
  </van-dialog>
</template>

<script>
import { getMdmCatgrByLevel } from '@/api/bargain'
export default {
  name: 'DetailsInfo',
  data() {
    return {
      mdmCatgOptions: []
    }
  },
  props: {
    detailsVisible: {
      type: Boolean
    },
    historyPriceList: {
      type: Array,
      default: () => []
    },
    detailsInfo: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    this.initMdmCatg()
  },
  methods: {
    async initMdmCatg() {
      const response = await getMdmCatgrByLevel({ catgLevel: '2' })
      this.mdmCatgOptions = response.data
    },
    getCatgName(mtartIn) {
      if (!this.mdmCatgOptions || !this.mdmCatgOptions.length) return mtartIn
      const data = this.mdmCatgOptions.find(item => item.catgId === mtartIn)
      if (!data) return mtartIn
      return data.catgName
    },
    getHistoryPriceList(matnr) {
      const data = this.historyPriceList.find(item => item && item.matnr === matnr)
      return data ? data.price : ''
    },
    close() {
      this.$emit('close-details-dialog')
    }
  }
}
</script>
<style lang="scss" scoped>
.details-container {
  height: 500px;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 20px;
}
</style>
